import { render, staticRenderFns } from "./stoppoint-attributes.vue?vue&type=template&id=094f2826"
import script from "./stoppoint-attributes.vue?vue&type=script&lang=js"
export * from "./stoppoint-attributes.vue?vue&type=script&lang=js"
import style0 from "./stoppoint-attributes.vue?vue&type=style&index=0&id=094f2826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports